import { withNamespaces } from 'react-i18next';
import {
    Card,
    CardBody,
} from 'reactstrap';

import RisksMap from './components/RisksMap';
import useRiskHeatmap from './hooks/useRiskHeatmap';

const RiskHeatmapSkeleton = () => (
    <Card>
        <CardBody>
            <div className="dt-field dt-skeleton mb-2" style={{ width: '20%' }} />
            <div className="dt-field dt-skeleton" style={{ width: '100%', height: '360px' }} />
        </CardBody>
    </Card>
);

const RiskHeatmap = ({
    t,
}) => {
    const {
        data,
        isLoading,
        isFetching,
        isError,
    } = useRiskHeatmap({ t });

    if (isLoading || isFetching) {
        return <RiskHeatmapSkeleton />;
    }

    if (isError || !data?.rating || !data?.allCountries) {
        return null;
    }

    return (
        <RisksMap
            countries={data.allCountries}
            ratings={data.rating}
        />
    );
};

export default withNamespaces()(RiskHeatmap);
